import type { Transition, RedirectToResult } from "@uirouter/react";

import {
    WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING,
    WEBSITE_ANALYSIS_MARKETING_REFERRAL_OUTGOING,
    WEBSITE_ANALYSIS_ROOT,
} from "app/pages/sales-intelligence/constants/routes";
import { IncomingTrafficContainer } from "app/pages/website-analysis/incoming-traffic/IncomingTrafficContainer";
import { OutgoingTrafficPage } from "app/pages/website-analysis/outgoing-traffic/OutgoingTrafficPage";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import { filterConsistencyParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { onRedirectWebsiteAnalysis } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsiteAnalysis";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const REFERRAL_GROUP_CONFIG: Record<
    string,
    IRouterState & { isPdfDownloadButton?: boolean; pdfDownloadsMethod?: () => Promise<any>; childStates?: any }
> = {
    [WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING]: {
        stateId: WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING,
        parent: WEBSITE_ANALYSIS_ROOT,
        url:
            // eslint-disable-next-line max-len
            "/referrals/incoming-traffic/:key/:isWWW/:country/:duration?webSource?referralsCategory?limits?orderBy?engagementTypeFilter?IncludeNewReferrals?IncludeTrendingReferrals?ExcludeUrls?IncludeUrls",
        component: IncomingTrafficContainer,
        redirectTo: onRedirectWebsiteAnalysis() as (transition: Transition) => RedirectToResult,
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "website",
            subSection: "traffic",
            subSubSection: "referrals",
        },
        trackingId: {
            section: "Account Review",
            subSection: "referral",
            subSubSection: "incomingTraffic",
        },
        defaultQueryParams: {
            webSource: "Total",
            duration: "3m",
            country: 999,
            isWWW: "*",
            ExcludeUrls: null,
            IncludeUrls: null,
        },
        childStates: {
            total: {
                configId: "TotalWebReferrals",
            },
        },
        hidePageTitle: true,
        pageTitle: "analysis.referrals.incoming.title",
        isUSStatesSupported: true,
        reloadOnSearch: false,
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        homeState: "salesIntelligence-home",
        reset: {
            ExcludeUrls: null,
            IncludeUrls: null,
        },
        params: {
            webSource: { dynamic: false },
            ...filterConsistencyParams,
        },
    },
    [WEBSITE_ANALYSIS_MARKETING_REFERRAL_OUTGOING]: {
        stateId: WEBSITE_ANALYSIS_MARKETING_REFERRAL_OUTGOING,
        parent: WEBSITE_ANALYSIS_ROOT,
        url: "/traffic-outgoing/:key/:isWWW/:country/:duration?webSource&outagoing_filters?selectedSite?outagoing_orderby",
        component: OutgoingTrafficPage,
        resolve: [resolvers.siteInfo],
        defaultQueryParams: {
            webSource: "Total",
            duration: "3m",
            country: 999,
            isWWW: "*",
        },
        params: {
            ...filterConsistencyParams,
        },
        pageId: {
            section: "website",
            subSection: "destination",
            subSubSection: "outgoing",
        },
        trackingId: {
            section: "Account Review",
            subSection: "referral",
            subSubSection: "outgoingTraffic",
        },
        childStates: {
            total: {
                configId: "TotalWebReferrals",
            },
        },
        pageTitle: "analysis.referrals.outgoing.title",
        isUSStatesSupported: true,
        reloadOnSearch: true,
        homeState: "salesIntelligence-home",
        redirectTo: redirectPipe(onRedirectWebsiteAnalysis()) as (transition: Transition) => RedirectToResult,
    },
};
